(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["art-info-block"] && !Shopify.designMode) return;
  try {
    if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', event => {
      const drawer = event.target.closest('.art-service-drawer');
      if (drawer) drawer.show();
    });
    document.addEventListener('shopify:block:deselect', event => {
      const drawer = event.target.closest('.art-service-drawer');
      if (drawer) drawer.hide();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
